function getPopoverPlacement(placement, spacing) {
    var placementMap = {
        'bottom-end': {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            },
            transformOrigin: {
                vertical: -spacing,
                horizontal: 'right',
            },
        },
        'bottom-start': {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: -spacing,
                horizontal: 'left',
            },
        },
        bottom: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
            transformOrigin: {
                vertical: -spacing,
                horizontal: 'center',
            },
        },
        'left-end': {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: -spacing,
            },
            transformOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            },
        },
        'left-start': {
            anchorOrigin: {
                vertical: 'top',
                horizontal: -spacing,
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
        },
        left: {
            anchorOrigin: {
                vertical: 'center',
                horizontal: -spacing,
            },
            transformOrigin: {
                vertical: 'center',
                horizontal: 'right',
            },
        },
        'right-end': {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            },
            transformOrigin: {
                vertical: 'bottom',
                horizontal: -spacing,
            },
        },
        'right-start': {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: -spacing,
            },
        },
        right: {
            anchorOrigin: {
                vertical: 'center',
                horizontal: 'right',
            },
            transformOrigin: {
                vertical: 'center',
                horizontal: -spacing,
            },
        },
        'top-end': {
            anchorOrigin: {
                vertical: -spacing,
                horizontal: 'right',
            },
            transformOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            },
        },
        'top-start': {
            anchorOrigin: {
                vertical: -spacing,
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
        },
        top: {
            anchorOrigin: {
                vertical: -spacing,
                horizontal: 'center',
            },
            transformOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
        },
    };
    return placementMap[placement];
}

export { getPopoverPlacement as g };
